module.exports = "<div>\n  <canvas #canvas class=\"online-chart\" id=\"line-chart\" [height]=\"getContainerHeight()\" [width]=\"getContainerWidth()\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard-chart-pane/dashboard-chart-pane.component.html
// module id = ./src/app/components/dashboard-chart-pane/dashboard-chart-pane.component.html
// module chunks = main